module.exports = __webpack_public_path__ + "static/SonderMind-00f567c47ff15d03a70b200acc112e6d.jpg";